import { fromJS, Map } from 'immutable';
import { pipe } from 'ramda';
import {
  convertListofActionsToActionDTO,
  groupByType
} from 'services/data-utils';

// ACTIONS
import {
  FETCH_ACTIONS_ERROR,
  FETCH_ACTIONS_SUCCESS,
  REQUEST_ACTIONS
} from 'actions/types';

const INITIAL_STATE = fromJS({
  all: {},
  error: null,
  loading: false
});

// SELECTORS

// REDUCER
export default function actions(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_ACTIONS:
      return state.set(INITIAL_STATE).merge({ loading: true });
    case FETCH_ACTIONS_SUCCESS:
      return state.merge({
        all: fromJS(
          pipe(convertListofActionsToActionDTO, groupByType)(action.data.items)
        ),
        error: null,
        loading: false
      });
    case FETCH_ACTIONS_ERROR:
      return state.merge({
        all: new Map(),
        error: action.err,
        loading: false
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/actions.js